import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { type LocalDateDTO } from 'gw-edge-client/dist/types/dto/pc/edge/time';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { convertDateToLocalDateDTO } from '../../utils/dateUtil';

export const quoteApprovedTimestampSelector = selector<LocalDateDTO>({
    key: 'getQuoteApprovedTimestamp',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);

        const timestamp = await OnlineSales.getQuoteApprovedTimestamp(jobNumber, sessionId);
        return {
            ...convertDateToLocalDateDTO(new Date()),
            hours_Top: 0,
            minutes_Top: 0,
            ...timestamp
        };
    }
});
